import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const outlinedInput = ({ palette }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiOutlinedInput"] => ({
	root: {
		borderRadius: "8px",
		backgroundColor: palette.white,
		borderWidth: "1px",
		fontSize: "14px",
		fontStyle: "normal",
		fontWeight: 400,
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: palette.grey40,
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: palette.primary,
			borderWidth: "1px",
		},
		"&.Mui-error": {
			backgroundColor: palette.whiteRed,
		},
		"&.Mui-error .MuiOutlinedInput-notchedOutline": {
			borderColor: palette.danger,
			borderWidth: "1px",
		},

		"&.Mui-disabled": {
			backgroundColor: palette.grey40,
		},
		"&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			borderColor: palette.grey40,
		},
	},
	input: {
		padding: "12.5px 0px 12.5px 16px",
	},

	notchedOutline: {
		borderColor: palette.white,
	},
});

export default outlinedInput;
